// C8b — **THE SIGN-IN CONFIRMATION, LIFTED OUT TO PAY THE R8 CEILING THIS ROUND SPENT.**
//
// The phone field, its own consent and their refusal path cost App.tsx thirty-one lines against ONE
// line of headroom, and R8's ledger rule is that the round pays as it goes — the ceiling ratchets
// DOWN and never up. This is the payment, in that ledger's favourite currency: **the thing that had
// to move is the thing nothing could reach.**
//
// It holds state (one flag and one timer), so it is the `TierCards` / `MicButton` class rather than
// one of the hookless leaves a gate CALLS — and **the reach it buys is the IMPORT**, which is what
// lets a fixture read the one thing that matters about this surface: that it shows a member's
// EMAIL ADDRESS only behind her own deliberate tap.
//
// **THAT IS WHY IT IS WORTH ITS OWN FILE RATHER THAN ANY THIRTY-SIX LINES.** LR1 ruling 3 is that
// the ONE name this house renders is the room first-name, with no field a surname or an email could
// ride in — and this control is the deliberate, member-initiated exception to it, on the one screen
// that has to answer *which account am I in* on a shared phone. A surface like that should be
// findable by name.
//
// Moved VERBATIM.

import { useEffect, useState } from "react";

export function SignInConfirmation({ room, email, onClose }: { room: string; email: string; onClose: () => void }) {
  const [showEmail, setShowEmail] = useState(false);

  useEffect(() => {
    // Once the email is showing she is reading it, so stop the clock and let her dismiss it.
    if (showEmail) return;
    const timer = window.setTimeout(onClose, 7000);
    return () => window.clearTimeout(timer);
  }, [showEmail, onClose]);

  return (
    <div className="signin-confirm" role="status" aria-live="polite">
      <button
        type="button"
        className="signin-confirm__body"
        onClick={() => setShowEmail((v) => !v)}
        aria-expanded={showEmail}
        title={showEmail ? "Hide the account" : "Show which account this is"}
      >
        <span className="signin-confirm__welcome">Welcome back, {room}</span>
        {showEmail ? (
          <span className="signin-confirm__email">{email}</span>
        ) : (
          <span className="signin-confirm__hint">Tap to see which account you are in</span>
        )}
      </button>
      <button type="button" className="signin-confirm__close" onClick={onClose} aria-label="Dismiss">
        x
      </button>
    </div>
  );
}
